import React, {useMemo } from 'react';
import { Button, Row, Col, Table, Label } from 'reactstrap';
import { SearchAsync } from '../../../../components/elements/SearchAsync';
import Select from 'react-select';


export const SearchClientQuoterMic = (props) => {

    const {
        
        checkTypeClient, tooglePatient, formQuoterMic, handleChangePatient, 
        listCompanies, handleChangeCompany, handleChangeAgreement, listAgreement,
        informationPatient, informationCompany
    } = props;
    

    const selectedCompany = useMemo(() => {
        return listCompanies.find(
            x => x.value === formQuoterMic.id_company
        ) || null;
    }, [listCompanies, formQuoterMic.id_company]);

    return (

        <div className="company-banner-content">
            {/* SELECTORS */}
            <div className="company-banner-selectors">

                {checkTypeClient === 1 && (
                    <div className="patient-search-wrapper">

                        <span
                            className="patient-create-btn"
                            onClick={tooglePatient}
                            title="Registrar paciente"
                        >
                            <i className="fa fa-user-plus"></i>
                        </span>

                        <div className="patient-search-container">

                            <SearchAsync
                                cacheOptions={false}
                                value={formQuoterMic.id_patient}
                                name="id_patient"
                                method={handleChangePatient}
                                loincState={formQuoterMic.searchPatientState}
                                url="Patient/SearchPatient"
                                maxLenght={3}
                                placeholder="Selecciona un paciente"
                                mDisabled={formQuoterMic.id_quatation > 0}
                            />

                        </div>

                    </div>
                )}

                {checkTypeClient === 3 && (
                    <>
                        <Select
                            isDisabled={formQuoterMic.id_quatation > 0}
                            classNamePrefix="company-select"
                            placeholder="Selecciona una empresa"
                            options={listCompanies}
                            value={selectedCompany}
                            onChange={handleChangeCompany}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            menuShouldBlockScroll
                            menuShouldScrollIntoView={false}
                            styles={{
                                menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 99999
                                }),
                                menu: (base) => ({
                                    ...base,
                                    zIndex: 99999
                                })
                            }}
                            // menuPortalTarget={document.body}
                            // menuPosition="fixed"
                        />

                        <Select
                            isDisabled={
                                !formQuoterMic.id_company ||
                                formQuoterMic.id_quatation > 0
                            }
                            classNamePrefix="company-select"
                            placeholder="Selecciona un convenio"
                            options={listAgreement}
                            value={formQuoterMic.id_agreement}
                            onChange={handleChangeAgreement}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            menuShouldBlockScroll
                            menuShouldScrollIntoView={false}
                            styles={{
                                menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 99999
                                }),
                                menu: (base) => ({
                                    ...base,
                                    zIndex: 99999
                                })
                            }}
                            // menuPortalTarget={document.body}
                            // menuPosition="fixed"
                        />
                    </>
                )}

            </div>

            {/* INFORMATION */}
            <div
                className={`company-banner-info ${(checkTypeClient === 3 && (!formQuoterMic.id_company || !formQuoterMic.id_agreement)) ||
                        (checkTypeClient === 1 && !informationPatient?.name)
                        ? "company-banner-disabled"
                        : ""
                    }`}
            >
                {/* COMPANY */}
                {checkTypeClient === 3 && informationCompany?.length > 0 && (
                    <>
                        <div className="company-item">
                            <i className="fa fa-phone" />
                            <div>
                                <span>Teléfono</span>
                                <strong>{informationCompany[0]?.phone || "-----"}</strong>
                            </div>
                        </div>
                        <div className="company-item">
                            <i className="fa fa-file-text-o" />
                            <div>
                                <span>Factura</span>
                                <strong>{informationCompany[0]?.require_invoice || "-----"}</strong>
                            </div>
                        </div>
                        <div className="company-item">
                            <i className="fa fa-credit-card" />
                            <div>
                                <span>Pago</span>
                                <strong>{informationCompany[0]?.payment || "-----"}</strong>
                            </div>
                        </div>
                        <div className="company-item company-email">
                            <i className="fa fa-envelope" />
                            <div>
                                <span>Correo</span>
                                <strong>{informationCompany[0]?.contact_email || "-----"}</strong>
                            </div>
                        </div>
                    </>
                )}

                {/* PATIENT */}
                {checkTypeClient === 1 && informationPatient?.name && (
                    <>

                        <div className="company-item">
                            <i className="fa fa-calendar" />
                            <div>
                                <span>Fecha Nac.</span>
                                <strong>{informationPatient.birthday ?? "----"}</strong>
                            </div>
                        </div>
                        <div className="company-item">
                            <i className="fa fa-phone" />
                            <div>
                                <span>Teléfono</span>
                                <strong>{informationPatient.phone ?? "----"}</strong>
                            </div>
                        </div>
                        <div className="company-item company-email">
                            <i className="fa fa-envelope" />
                            <div>
                                <span>Correo</span>
                                <strong>{informationPatient.email ?? "----"}</strong>
                            </div>
                        </div>
                    </>
                )}
            </div>

        </div>
    
    )
}
